'use strict';

module.exports = {
  name: 'Bee Monistoring System',
  kind: 'Beemos',
  numberParameters: 52,
  numberLogParameters: 26,
  id: 'B',
  description: 'Bee Monitoring System data result',
  url: '',
  parameters: [
    {
      label: 'A',
      variable: 'externalTemperature',
      name: 'Ext temperature',
      description: 'External temperature',
      factor: 100,
      unit: '°C',
      writable: false,
    },
    {
      label: 'B',
      variable: 'externalHumidity',
      name: 'Ext humidity',
      description: 'External humidity',
      factor: 100,
      unit: '%',
      writable: false,
    },
    {
      label: 'C',
      variable: 'pressure',
      name: 'Pressure',
      description: 'Press',
      factor: 10,
      unit: 'mbar',
      writable: false,
    },
    {
      label: 'D',
      variable: 'luminosity',
      name: 'Luminosity',
      description: 'Luminosity (Arbitrary unit)',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'E',
      variable: 'red',
      name: 'Red',
      description: 'Red luminosity (Arbitrary unit)',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'F',
      variable: 'green',
      name: 'Green',
      description: 'Green luminosity (Arbitrary unit)',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'G',
      variable: 'blue',
      name: 'Blue',
      description: 'Blue luminosity (Arbitrary unit)',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'H',
      variable: 'infrared',
      name: 'Infrared',
      description: 'Infrared luminosity (Arbitrary unit)',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'I',
      variable: 'latitude',
      name: 'Latitude',
      description: 'Latitude',
      factor: 100,
      unit: '°',
      writable: false,
    },
    {
      label: 'J',
      variable: 'longitude',
      name: 'Longitude',
      description: 'Longitude',
      factor: 100,
      unit: '°',
      writable: false,
    },
    {
      label: 'K',
      variable: 'internalTemperature',
      name: 'Int temperature',
      description: 'Internal temperature',
      factor: 100,
      unit: '°C',
      writable: false,
    },
    {
      label: 'L',
      variable: 'internalHumidity',
      name: 'Int humidity',
      description: 'Internal humidity',
      factor: 100,
      unit: '%',
      writable: false,
    },
    {
      label: 'M',
      variable: 'internalTemperatureA',
      name: 'Int temperature A',
      description: 'Internal temperature A',
      factor: 100,
      unit: '°C',
      writable: false,
    },
    {
      label: 'N',
      variable: 'internalTemperatureB',
      name: 'Int temperature B',
      description: 'Internal temperature B',
      factor: 100,
      unit: '°C',
      writable: false,
    },

    {
      label: 'O',
      variable: 'weightInternalUnit',
      name: 'Weight internal unit',
      description: 'Weight in internal unit',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'P',
      variable: 'weight',
      name: 'Weight',
      description: 'Weight',
      factor: 100,
      unit: 'kg',
      writable: false,
    },

    {
      label: 'Q',
    },

    {
      label: 'R',
    },

    {
      label: 'S',
    },

    {
      label: 'T',
    },

    {
      label: 'U',
    },

    {
      label: 'V',
    },

    {
      label: 'W',
      variable: 'battery',
      name: 'Battery',
      description: 'Battery voltage',
      factor: 1000,
      unit: 'V',
      writable: false,
    },
    {
      label: 'X',
      variable: 'charging',
      name: 'Charging',
      description: 'Indication showing if the battery is charging',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'Y',
      variable: 'rssi',
      name: 'Wifi RSSI',
      description: 'Power of Wifi signal',
      factor: 1,
      unit: 'dB',
      writable: false,
    },
    {
      label: 'Z',
      variable: 'error',
      name: 'Error',
      description: 'Current error code',
      factor: 1,
      unit: '',
      writable: false,
    },

    {
      label: 'AA',
      variable: 'loggingInterval',
      name: 'Logging interval',
      description: 'Interval in seconds between logs',
      factor: 1,
      unit: 's',
      writable: true,
    },
    {
      label: 'AB',
      variable: 'weightOffset',
      name: 'Weight offset',
      description: 'Offset to convert weight from internal unit',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AC',
      variable: 'weightFactor',
      name: 'Weight factor',
      description: 'Factor to convert the weight from internal unit',
      factor: 1,
      unit: '',
      writable: false,
    },

    {
      label: 'AD',
    },

    {
      label: 'AE',
    },

    {
      label: 'AF',
    },

    {
      label: 'AG',
    },

    {
      label: 'AH',
    },

    {
      label: 'AI',
    },

    {
      label: 'AJ',
    },

    {
      label: 'AK',
      variable: 'gate1In',
      name: 'Gate 1 IN',
      description: 'Number of input on gate 1',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AL',
      variable: 'gate1Out',
      name: 'Gate 1 OUT',
      description: 'Number of output on gate 1',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AM',
      variable: 'gate2In',
      name: 'Gate 2 IN',
      description: 'Number of input on gate 2',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AN',
      variable: 'gate2Out',
      name: 'Gate 2 OUT',
      description: 'Number of output on gate 2',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AO',
      variable: 'gate3In',
      name: 'Gate 3 IN',
      description: 'Number of input on gate 3',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AP',
      variable: 'gate3Out',
      name: 'Gate 3 OUT',
      description: 'Number of output on gate 3',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AQ',
      variable: 'gate4In',
      name: 'Gate 4 IN',
      description: 'Number of input on gate 4',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AR',
      variable: 'gate4Out',
      name: 'Gate 4 OUT',
      description: 'Number of output on gate 4',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AS',
      variable: 'gate5In',
      name: 'Gate 5 IN',
      description: 'Number of input on gate 5',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AT',
      variable: 'gate5Out',
      name: 'Gate 5 OUT',
      description: 'Number of output on gate 5',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AU',
      variable: 'gate6In',
      name: 'Gate 6 IN',
      description: 'Number of input on gate 6',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AV',
      variable: 'gate6Out',
      name: 'Gate 6 OUT',
      description: 'Number of output on gate 6',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AW',
      variable: 'gate7In',
      name: 'Gate 7 IN',
      description: 'Number of input on gate 7',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AX',
      variable: 'gate7Out',
      name: 'Gate 7 OUT',
      description: 'Number of output on gate 7',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AY',
      variable: 'gate8In',
      name: 'Gate 8 IN',
      description: 'Number of input on gate 8',
      factor: 1,
      unit: '',
      writable: false,
    },
    {
      label: 'AZ',
      variable: 'gate8Out',
      name: 'Gate 8 OUT',
      description: 'Number of output on gate 8',
      factor: 1,
      unit: '',
      writable: false,
    },
  ],
};
